import React, { createContext, useState, useEffect } from 'react';
import _ from 'lodash';

import { useAuth } from 'contexts/auth';
import { Icon, Stack } from 'shell/components';
import { useHistory } from 'react-router-dom';

const COUNTRY_OPTIONS = [
    {
        key: 'canada',
        value: (
            <Stack alignItems={'center'} direction={'row'} spacing={2}>
                <Icon kind={'canada'} />
                Canada
            </Stack>
        ),
    },
    {
        key: 'usa',
        value: (
            <Stack alignItems={'center'} direction={'row'} spacing={2}>
                <Icon kind={'usa'} />
                USA
            </Stack>
        ),
    },
];

const defaultForm = {
    email: '',
    password: '',
};

const defaultErrors = {
    email: '',
    password: '',
    login_failed: '',
};

const PageContext = createContext();

const PageProvider = (props) => {
    const history = useHistory();
    const { login } = useAuth();

    const [loading, setLoading] = useState(false);
    const [country, setCountry] = useState(COUNTRY_OPTIONS[0].key);
    const [form, setForm] = useState(defaultForm);
    const [errors, setErrors] = useState(defaultErrors);

    const getErrorMessage = (key, value) => {
        value = value?.trim();
        switch (key) {
            case 'email':
                return value ? '' : 'Email or password is invalid';
            case 'password':
                return value ? '' : 'Email or password is invalid';
            default:
                return '';
        }
    };

    const validate = (key, value) => {
        const errorMessage = getErrorMessage(key, value);
        setErrors((errors) => {
            return {
                ...errors,
                [key]: errorMessage,
            };
        });
    };

    const handleChange = (key, value) => {
        switch (key) {
            case 'email':
            case 'password': {
                setForm((current) => ({ ...current, [key]: value }));
                validate(key, value);
                return;
            }
            case 'country': {
                const currentUrl = window.location.origin;
                setCountry(value);
                if (value === 'canada' && currentUrl !== 'https://app.ensightful.ca') {
                    return window.location.replace('https://app.ensightful.ca');
                } else if (value === 'usa' && currentUrl !== 'https://app.ensightful.us') {
                    return window.location.replace('https://app.ensightful.us');
                }
            }

            default:
                return;
        }
    };

    const handleClickLogin = async () => {
        try {
            setLoading(true);
            const loginCallback = await login({ username: form.email, password: form.password });
            setLoading(false);
            switch (loginCallback) {
                case 'profile-set-up': {
                    return history.push('/profile-setup');
                }

                case 'login': {
                    return history.push('/');
                }

                default: {
                    throw new Error();
                }
            }
        } catch (e) {
            console.error(e);
            setLoading(false);
            setErrors((errors) => {
                return {
                    ...errors,
                    email: 'The email or password you entered is incorrect',
                    password: 'The email or password you entered is incorrect',
                };
            });
        }
    };

    const handleClickButton = (key) => {
        switch (key) {
            case 'login': {
                return handleClickLogin();
            }

            default: {
                return;
            }
        }
    };

    useEffect(() => {
        const region = process.env.REACT_APP_AWS_REGION;
        if (region === 'ca-central-1') {
            setCountry(COUNTRY_OPTIONS[0].key);
        } else if (region === 'us-east-1') {
            setCountry(COUNTRY_OPTIONS[1].key);
        } else {
            setCountry(COUNTRY_OPTIONS[1].key);
        }
    }, []);

    return (
        <PageContext.Provider
            value={{
                loading,
                country,
                form,
                errors,

                handleChange,
                handleClickButton,
                COUNTRY_OPTIONS,
            }}
            {...props}
        />
    );
};

export { PageContext };
export default PageProvider;
